export default "__VITE_ASSET__5d401fa1__"